import { Company } from '../models/company.model';

export const StubCompany: Company = {
  _id: '',
  name: '',
  dateOfEstablishment: new Date(),
  fiscalYearStartMonth: 1,
  fiscalYearStartDay: 1,
  address: '',
  email: '',
  website: '',
  phone: '',
  shortName: '',
  baseCurrency: '',
  companyId: '',
  taxId: '',

  mainPlaceOfWork: '',
  otherPlacesOfWork: [],
  businessType: '',

  creativeIndustrySector: '',
  marketDomains: [],
  keyServices: [],
  jurisdictionResidency: '',
  numberOfMembers: 0,

  sealUrl: '',
  signatureUrl: '',
  logoUrl: '',

  instagram: '',
  linkedin: '',
  tiktok: '',
  youtube: '',
  imdb: '',
  vimeo: '',
  x: '',
  additionalSocialMediaChannels: [],

  createdAt: new Date(),
  updatedAt: new Date(),
};
